import React, { useMemo } from "react";
import { programmeDeloadWeeks } from "../../config/periodisation";
import { formatSlotDay, slotDate } from "../../utils/programmeSchedule";
import { formatWeekRange } from "../../utils/programmeSchedule";
import { Accordion } from "../ui/accordion";
import TimelineWeek from "./TimelineWeek";

const ProgrammeTimeline = ({
  programme,
  currentWeek,
  nextSessionId,
  onSessionClick,
  onEditSession,
  onClearSession,
  onReorder,
  onPlanWeek,
}) => {
  // Default open: current week and next week
  const defaultOpen = useMemo(() => {
    const open = [];
    for (const week of programme.weeks) {
      if (week.week_number >= currentWeek && week.week_number <= currentWeek + 1) {
        open.push(`week-${week.week_number}`);
      }
    }
    return open;
  }, [programme.weeks, currentWeek]);

  const deloads = useMemo(() => programmeDeloadWeeks(programme), [programme]);

  // The next-up card now sits above the weeks, so the page no longer scrolls
  // itself down to the current week on open.
  return (
    <div className="grid gap-2.5">
      <h3 className="text-xs font-semibold text-muted-foreground">Weeks</h3>
      <Accordion type="multiple" defaultValue={defaultOpen} className="grid gap-2.5">
        {programme.weeks.map((week) => (
          <TimelineWeek
            key={week.week_number}
            week={{
              ...week,
              // Each day's date (#92), shown at the start of its subtitle.
              sessions: (week.sessions || []).map((s) => ({
                ...s,
                dayLabel:
                  s.unplaced && s.status === "pending"
                    ? "Not on a day"
                    : formatSlotDay(slotDate(programme, { ...s, week_number: s.week_number ?? week.week_number })),
              })),
            }}
            isCurrent={week.week_number === currentWeek}
            isDeload={deloads.includes(week.week_number)}
            dateRange={formatWeekRange(programme, week.week_number)}
            nextSessionId={nextSessionId}
            onSessionClick={onSessionClick}
            onEditSession={onEditSession}
            onClearSession={onClearSession}
            onReorder={onReorder}
            onPlanWeek={onPlanWeek && week.week_number >= currentWeek ? () => onPlanWeek(week.week_number) : undefined}
          />
        ))}
      </Accordion>
    </div>
  );
};

export default ProgrammeTimeline;
